import * as HttpService from './http.service';
import { SEND_LOGIN_OTP_URL, VERIFY_AZURE_AD_TOKEN_URL, VERIFY_LOGIN_OTP_URL } from './url.service';

export const verifyLoginOtp = (data) => HttpService.postWithOutAuth(VERIFY_LOGIN_OTP_URL, data);

export const verifyAzureToken = (data) => HttpService.postWithOutAuth(VERIFY_AZURE_AD_TOKEN_URL, data);

export const sendLoginOtp = (data) => HttpService.postWithOutAuth(SEND_LOGIN_OTP_URL, data);
